var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAFlagChile = function SvgAFlagChile(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 14,
    viewBox: "0 0 18 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 14H0V0H18V14Z",
    fill: "#D52B1E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 7H18V0H0L6 7Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 7H0V0H7V7Z",
    fill: "#0039A6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2 2.89548L2.92725 3.60386L2.57338 4.75L3.5 4.04162L4.42662 4.75L4.07275 3.60386L5 2.89548H3.85387L3.5 1.75L3.14613 2.89548H2Z",
    fill: "white"
  })));
};
export { SvgAFlagChile as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTgiIGhlaWdodD0iMTQiIHZpZXdCb3g9IjAgMCAxOCAxNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE4IDE0SDBWMEgxOFYxNFoiIGZpbGw9IiNENTJCMUUiLz4KPHBhdGggZD0iTTYgN0gxOFYwSDBMNiA3WiIgZmlsbD0id2hpdGUiLz4KPHBhdGggZD0iTTcgN0gwVjBIN1Y3WiIgZmlsbD0iIzAwMzlBNiIvPgo8cGF0aCBkPSJNMiAyLjg5NTQ4TDIuOTI3MjUgMy42MDM4NkwyLjU3MzM4IDQuNzVMMy41IDQuMDQxNjJMNC40MjY2MiA0Ljc1TDQuMDcyNzUgMy42MDM4Nkw1IDIuODk1NDhIMy44NTM4N0wzLjUgMS43NUwzLjE0NjEzIDIuODk1NDhIMloiIGZpbGw9IndoaXRlIi8+Cjwvc3ZnPgo=";